import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import type { ApiResponse, AvailableIdentifiersResponse } from '@/types';

/**
 * The destinations an operator can pick from, read live from each connected helpdesk.
 *
 * This is all that is left of the channel-identifier API. A destination is written when
 * its inbox is created and lives on that inbox's own channel row, so there is nothing to
 * list, attach or detach separately: reading an inbox reads its destination, and changing
 * one means deleting the inbox and making another.
 */
export const channelIdentifiersService = {
  /** Never throws on a dead provider token — see `provider_lookup_failed` on the response. */
  async available(accountId: number): Promise<AvailableIdentifiersResponse> {
    const res = await api.get<ApiResponse<AvailableIdentifiersResponse>>(
      API_ENDPOINTS.CHANNEL_IDENTIFIERS.AVAILABLE(accountId)
    );
    return res.data.data;
  }
};
